import createIcon from '../../createIcon';

/**
 * @component @name SkipPrevious
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiA2SDhWMThINlY2Wk05LjUgMTJMMTggMThWNkw5LjUgMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SkipPrevious = createIcon('SkipPrevious', [
  ['path', { d: 'M6 6H8V18H6V6ZM9.5 12L18 18V6L9.5 12Z', key: 'ovfyr9' }],
]);

export default SkipPrevious;
